export const arrayNotEqual = (arr1, arr2) => {
  if (arr1 === null) arr1 = []
  if (arr2 === null) arr2 = []
  return !(arr1.every(e => arr2.includes(e)) && arr1.length === arr2.length)
}